import { COLORS } from '../../../../../../constants';

const styles = {
  leftButton: {},
  rightButton: {
    marginLeft: 10,
  },
  progress: {
    marginLeft: 10,
    color: COLORS.GREEN,
  },
};

export default styles;
